export type CheckoutStepName = "DELIVERY" | "PAYMENT" | "SUMMARY";
export type CheckoutStep = {
	readonly name: CheckoutStepName;
	readonly url: string;
	readonly trackingName: string;
};
export class CheckoutSteps {
	// this is the only step when the simple mode is activated for checkout
	static Delivery: CheckoutStep = {
		name: "DELIVERY",
		url: "/delivery",
		trackingName: "checkout:delivery",
	};
	static Payment: CheckoutStep = {
		name: "PAYMENT",
		url: "/payments",
		trackingName: "checkout:payment",
	};
	static Summary: CheckoutStep = {
		name: "SUMMARY",
		url: "/summary",
		trackingName: "checkout:summary",
	};
	static threeStepCheckout: Array<CheckoutStep> = [
		CheckoutSteps.Delivery,
		CheckoutSteps.Payment,
		CheckoutSteps.Summary,
	];
	static lastStep = CheckoutSteps.Summary;

	static getStepNumber(step: CheckoutStep): number {
		return CheckoutSteps.threeStepCheckout.indexOf(step) + 1;
	}
}
